import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Player extends Component {
    constructor(props) {
        super(props);
        this.playerRef = React.createRef();
        require('./player.scss');
        //console.log("[Player] props", props);
    }

    componentDidMount() {
        this.props.onReady(this.props.config, this.playerRef.current);
    }
    shouldComponentUpdate(nextProps) {
        return this.props.config.videoId != nextProps.config.videoId
    }
    componentDidUpdate() {
        //console.log("[Player] Update:",this.props);
        this.props.onUpdate(this.props.config);
    }
    componentWillUnmount() {
        this.props.onDestroy();
    }

    render() {
        const { controls, showTitle } = this.props;
        let className = cx({
            "media-player": true,
            "hide-title-card": showTitle === false,
            "hide-cc": controls.cc === false,
            "hide-time-display": controls["time-display"] === false,
            "hide-fullscreen": controls.fullscreen === false,
            "hide-progress-bar": controls["progress-bar"] === false,
            "hide-volume": controls.volume === false
        })
        return (
            <section ref={this.playerRef} className={className} >
            </section>
        );

    }
    static get propTypes() {
        return {
            player: PropTypes.object,
            config: PropTypes.object,
            onUpdate: PropTypes.func,
            onDestroy: PropTypes.func,
            onReady: PropTypes.func,
            controls: PropTypes.object,
            showTitle: PropTypes.bool
        }
    }

    static get defaultProps() {
        return {
            player: null,
            config: null,
            onReady: () => {},
            onUpdate: () => {},
            onDestroy: () => {},
            controls: {},
            showTitle: true
        }
    }
}